// Localized mapping from CSAM short application codes to human-readable names
// Use $localize so labels are extractable and translatable.
export function getLocalizedCsamApplication(): Record<string, string> {
    return {
        'VAT': $localize`:@@csamApp.VAT:BTW`,
        'UBO': $localize`:@@csamApp.UBO:UBO-REGISTER`,
        'TOW_IPP': $localize`:@@csamApp.TOW_IPP:Tax-on-web PB`,
        'TOW_INR': $localize`:@@csamApp.TOW_INR:Tax-on-web BNI/NP`,
        'MYMINFIN': $localize`:@@csamApp.MYMINFIN:MYMINFIN`,
        'FINPROF': $localize`:@@csamApp.FINPROF:FINPROF`,
        'BIZTAX': $localize`:@@csamApp.BIZTAX:BIZTAX`,
        'BEPS13': $localize`:@@csamApp.BEPS13:BEPS13`,
        'MDT-IPPINR-PRO': $localize`:@@csamApp.MDT_IPPINR_PRO:Belastingaangifte PB-BNI`,
    };
}

